import {
    Formik,
    FormikProps
} from 'formik';

import {FormComponent} from './FormComponent';

import {RecordSchema} from './RecordSchema';

import {FormWithButtons} from '@flexinet/ui-components';

import {
    Account,
    AccountStatus,
    AccountType
} from '../types';
import {useNavigate} from "react-router-dom";
import {stage} from "../../../../config/stage";

export const RecordForm = ({
                               record,
                               handleSubmit,
                           }: {
    // Optional: the Add page has no record yet (FNP-945).
    record?: Omit<Account, 'id'>,
    handleSubmit: (values: Account) => void
}) => {
    const navigate = useNavigate()

    const onSubmit = (values: Account) => {
        console.debug(values)
        handleSubmit(values);
        navigate('/accounts');
    };

    const onCancel = () => {
        navigate('/accounts');
    };


    let initialValues = {
        id: '',
        sub: '',
        email: '',
        accountType: AccountType.STANDALONE,
        accountStatus: AccountStatus.ACTIVE,
    } as Account;

    if (record) {
        initialValues = {...initialValues, ...record};
    }

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={RecordSchema}
            onSubmit={onSubmit}
        >
            {({
                  handleSubmit,
                  isSubmitting,
                  ...rest
              }) => (
                <FormWithButtons handleSubmit={handleSubmit} isSubmitting={isSubmitting}
                                 handleCancel={onCancel} debug={false && stage === 'ide'} {...rest} >
                    <FormComponent {...rest as FormikProps<Account>}  />
                </FormWithButtons>)}
        </Formik>
    );
};
